// @flow
import React from 'react';
import type { Categories } from 'store/modules/events';
import EventLikeButton from 'components/event/EventLikeButton';
import { fromNow } from 'lib/common';
import EventActionButtons from '../EventActionButtons';
import EventMobileShare from '../EventMobileShare/EventMobileShare';
import './EventHead.scss';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownEvent: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const EventHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownEvent,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="EventHead">
      {/* <h1>{title}</h1> */}
      <div className="date-and-likes">
        {/* <div className="date">{fromNow(date)}</div> */}
        {/* <div className="placeholder" /> */}
        <EventMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <EventLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      {/* <div className="separator" /> */}
      {ownEvent && <EventActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

EventHead.Placeholder = () => (
  <div className="EventHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default EventHead;



// WEBPACK FOOTER //
// ./src/components/event/EventHead/EventHead.js